import Layout from '@/components/layout/index.vue'

export default {
  path: 'deliveryappointment',
  name: 'Deliveryappointment',
  meta: {},
  component: Layout,
  redirect: { name: 'Deliveryappointment.Uploadpoint' },
  children: [
    {
      path: 'uploadpoint',
      name: 'Deliveryappointment.Uploadpoint',
      meta: {},
      component: () => import(/* webpackChunkName: "deliveryappointment" */ '@/views/purchaser/deliveryappointment/uploadpoint/index.ts')
    },
    {
      path: 'uploadpoint/add',
      name: 'Deliveryappointment.Uploadpoint.Add',
      meta: { title: 'common.add', dep: 'Deliveryappointment.Uploadpoint' },
      component: () => import(/* webpackChunkName: "deliveryappointment" */ '@/views/purchaser/deliveryappointment/uploadpoint/add.ts')
    },
    {
      path: 'uploadpoint/modify/:id',
      name: 'Deliveryappointment.Uploadpoint.Modify',
      meta: { title: 'common.modify', dep: 'Deliveryappointment.Uploadpoint' },
      component: () => import(/* webpackChunkName: "deliveryappointment" */ '@/views/purchaser/deliveryappointment/uploadpoint/modify.ts')
    },
    {
      path: 'parking-schedule',
      name: 'Deliveryappointment.ParkingSchedule',
      meta: {},
      component: () => import(/* webpackChunkName: "deliveryappointment" */ '@/views/purchaser/deliveryappointment/parking-schedule/index.ts')
    },
    {
      path: 'parking-schedule/add',
      name: 'Deliveryappointment.ParkingSchedule.Add',
      meta: { title: 'common.add', dep: 'Deliveryappointment.ParkingSchedule' },
      component: () => import(/* webpackChunkName: "deliveryappointment" */ '@/views/purchaser/deliveryappointment/parking-schedule/add.vue')
    },
    {
      path: 'parking-schedule/modify',
      name: 'Deliveryappointment.ParkingSchedule.Modify',
      meta: { title: 'common.modify', dep: 'Deliveryappointment.ParkingSchedule' },
      component: () => import(/* webpackChunkName: "deliveryappointment" */ '@/views/purchaser/deliveryappointment/parking-schedule/modify.vue')
    },
    {
      path: 'urgentreservation',
      name: 'Deliveryappointment.Urgentreservation',
      meta: {},
      component: () => import(/* webpackChunkName: "deliveryappointment" */ '@/views/purchaser/deliveryappointment/urgentreservation/index.ts')
    },
    {
      path: 'urgentreservation/add',
      name: 'Deliveryappointment.Urgentreservation.Add',
      meta: { title: 'common.add', dep: 'Deliveryappointment.Urgentreservation' },
      component: () => import(/* webpackChunkName: "deliveryappointment" */ '@/views/purchaser/deliveryappointment/urgentreservation/add.vue')
    },
    {
      path: 'urgentreservation/perfect/:appointUuid',
      name: 'Deliveryappointment.Urgentreservation.Perfect',
      meta: { title: 'deliveryappointment.urgentreservation.perfect', dep: 'Deliveryappointment.Urgentreservation' },
      component: () => import(/* webpackChunkName: "deliveryappointment" */ '@/views/purchaser/deliveryappointment/urgentreservation/perfect.vue')
    },
    {
      path: 'parkinglot',
      name: 'Deliveryappointment.Parkinglot',
      meta: {},
      component: () => import(/* webpackChunkName: "deliveryappointment" */ '@/views/purchaser/deliveryappointment/parkinglot/index.ts')
    },
    {
      path: 'parkinglot/add',
      name: 'Deliveryappointment.Parkinglot.Add',
      meta: { title: 'common.add', dep: 'Deliveryappointment.Parkinglot' },
      component: () => import(/* webpackChunkName: "deliveryappointment" */ '@/views/purchaser/deliveryappointment/parkinglot/add.ts')
    },
    {
      path: 'parkinglot/modify/:id',
      name: 'Deliveryappointment.Parkinglot.Modify',
      meta: { title: 'common.modify', dep: 'Deliveryappointment.Parkinglot' },
      component: () => import(/* webpackChunkName: "deliveryappointment" */ '@/views/purchaser/deliveryappointment/parkinglot/modify.ts')
    },
    {
      path: 'approveappointment',
      name: 'Deliveryappointment.Approveappointment',
      meta: {},
      component: () => import(/* webpackChunkName: "deliveryappointment" */ '@/views/purchaser/deliveryappointment/approveappointment/index.ts')
    },
    {
      path: 'approveappointment/review/:appointId',
      name: 'Deliveryappointment.Approveappointment.Review',
      meta: { title: '审核', dep: 'Deliveryappointment.Approveappointment' },
      component: () => import(/* webpackChunkName: "deliveryappointment" */ '@/views/purchaser/deliveryappointment/approveappointment/review.ts')
    },
    {
      path: 'approveappointment/scheduling/:appointId',
      name: 'Deliveryappointment.Approveappointment.Scheduling',
      meta: { title: '调度', dep: 'Deliveryappointment.Approveappointment' },
      component: () => import(/* webpackChunkName: "deliveryappointment" */ '@/views/purchaser/deliveryappointment/approveappointment/scheduling.ts')
    }
  ]
}
